import { Link } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import { useLanguage } from "../../context/LanguageContext";
export const RequestSuccess = ({ order }) => {
  const { t } = useLanguage();
  return <div data-testid="order-request-success" className="text-center">
    <CheckCircle2 size={44} className="mx-auto text-[#10B981]" />
    <h2 className="mt-4 font-display text-2xl font-bold text-slate-50">{t("Request received")}</h2>
    <p className="mx-auto mt-3 max-w-md text-sm leading-relaxed text-slate-400">{t("Thank you, {{name}}. Your reference is {{reference}}. The Evi-Studio team will contact you at {{email}} with a personal proposal for your project.", { name: order.form.first_name, reference: order.orderId, email: order.form.email })}</p>
    <Link to="/" data-testid="order-success-home-link" className="btn-ghost mt-8">{t("Back to Home")}</Link>
  </div>;
};